// import { Button, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
// import ModalNotificationFinep from "../../ModalNotificationFinep";
// import { useState } from "react";
// import useLoading from "../../../Hooks/useLoading";
// import Loader from "../Loader";
// import { IResponseProps } from "../../../Interfaces/IResponseProps";
// import { GetTenantIdSession } from "../../../Utils/StorageSessions";
// import { GetAllExternalEmailsByTenantAPI } from "../../../API/FinepNotification";
// import { ExternalRoles } from "../../../Static/Roles";
// import useCan from "../../../Hooks/useCan";

// interface ITabsHeaderProps {
//     valueSelected?: boolean,
//     setValueSelected?: React.Dispatch<React.SetStateAction<boolean>>,
//     changeValidate?: (isValid: boolean) => Promise<void>;
//     canValidate?: boolean,
//     cardName?: string,
//     tabName?: string,
//     registerId?: string
// }

// const TabsHeader = (props: ITabsHeaderProps) => {
//     const [open, setOpen] = useState<boolean>(false);
//     const [emails, setEmails] = useState<string[]>([]);
//     const { loading, toggleLoading } = useLoading();
//     const canSee = useCan({ rolesCan: ["Administrator", "Manager", "Consultant"] });

//     const handleClose = () => setOpen(!open);

//     const getEmails = async () => {
//         try {
//             toggleLoading(true);
//             var tenantId = GetTenantIdSession();

//             await GetAllExternalEmailsByTenantAPI(tenantId).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     setEmails(resp.data.resp);
//                     handleClose();
//                 }
//             });
//         } catch (error: any) {

//         } finally {
//             toggleLoading(false);
//         }
//     }

//     return (
//         <>
//             {loading && <Loader />}
//             <div className="d-flex justify-content-end align-items-center mt-2 w-100">
//                 {props.canValidate &&
//                     <div className="d-flex align-items-center">
//                         <span className="me-4">Validado ?</span>
//                         <FormControl className="me-2">
//                             <InputLabel id="labelId">Selecione</InputLabel>
//                             <Select
//                                 labelId="labelId"
//                                 className="me-4 select-width"
//                                 label="Selecione"
//                                 disabled={!canSee}
//                                 value={props.valueSelected?.toString()}
//                                 onChange={e => props.changeValidate ? props.changeValidate(JSON.parse(e.target.value)) : props.setValueSelected && props.setValueSelected(JSON.parse(e.target.value))}
//                             >
//                                 <MenuItem value="true">Sim</MenuItem>
//                                 <MenuItem value="false">Não</MenuItem>
//                             </Select>
//                         </FormControl>
//                     </div>
//                 }
//                 {canSee &&
//                     <div>
//                         <Button onClick={getEmails} variant="contained" size="large">
//                             Notificarr
//                         </Button>
//                     </div>
//                 }
//             </div>
//             <ModalNotificationFinep
//                 open={open}
//                 handleClose={handleClose}
//                 emailsToSelect={emails}
//                 toggleLoading={toggleLoading}
//                 cardName={props.cardName ?? ""}
//                 registerId={props.registerId ?? ""}
//                 tabName={props.tabName ?? ""}
//             />
//         </>
//     );
// }

// export default TabsHeader;


import { useState } from "react";
import { Button } from "antd";
import { CheckCircleOutlined, SyncOutlined } from "@ant-design/icons";
import useLoading from "../../../Hooks/useLoading";
import Loader from "../Loader";
import useCan from "../../../Hooks/useCan";
interface ITabsHeaderProps {
    valueSelected?: boolean;
    setValueSelected?: React.Dispatch<React.SetStateAction<boolean>>;
    changeValidate?: (isValid: boolean) => Promise<void>;
    canValidate?: boolean;
    registerId?: string;
    cardName?: string;
    tabName?: string;
}
const TabsHeader = (props: ITabsHeaderProps) => {
    const { loading } = useLoading();
    const canSee = useCan({ rolesCan: ["Administrator", "Manager", "Consultant"] });
    const [isValidated, setIsValidated] = useState(props.valueSelected ?? false);
    const toggleValidation = async () => {
        const newStatus = !isValidated;
        setIsValidated(newStatus);
        if (props.changeValidate) {
            await props.changeValidate(newStatus);
        } else if (props.setValueSelected) {
            props.setValueSelected(newStatus);
        }
    };
    return (
        <>
            {loading && <Loader />}
            <div className="d-flex justify-content-between align-items-center mt-2 w-100">
                <div>
                    <strong>{props.cardName}</strong>  {props.tabName}
                </div>
                {props.canValidate && (
                    <div className="d-flex align-items-center">
                        <Button
                            type="primary"
                            onClick={toggleValidation}
                            style={{ backgroundColor: "#0000A4", borderColor: "#0000A4", marginRight: "8px" }}
                        >
                            Validar
                        </Button>
                        <Button
                            type="default"
                            icon={isValidated ? <CheckCircleOutlined /> : <SyncOutlined />}
                            style={{
                                color: isValidated ? "#52C41A" : "#0000A4",
                                borderColor: isValidated ? "#B7EB8F" : "#6B6BFF",
                                backgroundColor: isValidated ? "#F6FFED" : "#E5E5FF"
                            }}
                        >
                            {isValidated ? "Validado" : "Em validação"}
                        </Button>
                    </div>
                )}
            </div>
        </>
    );
};
export default TabsHeader;